import { useTagGroup } from "../tags/queries/useTagGroup";
export const useJobStates = () => useTagGroup([], "jobstates");
